import {Authenticated, CanAccess} from '@refinedev/core';
import {ErrorComponent} from '@refinedev/mui';
import {CatchAllNavigate} from '@refinedev/react-router';
import {Suspense} from 'react';
import {Outlet, Route, Routes as RouterRoutes} from 'react-router';

import {DashboardContent, DashboardLayout} from '@minimal/layouts/dashboard';
import {Login} from '@pages/login';
import * as Bdese from '@workspaces/bdese';
import * as Global from '@workspaces/global';
import * as Nemesis from '@workspaces/nemesis';
import * as PilotageRh from '@workspaces/pilotage-rh';
import {WorkspaceList, workspacesBasePath} from '@workspaces/workspaces';

export const Routes = () => {
  const routes = [
    {
      path: workspacesBasePath[WorkspaceList.BDESE],
      element: <Bdese.Routes />,
    },
    {
      path: workspacesBasePath[WorkspaceList.NEMESIS],
      element: <Nemesis.Routes />,
    },
    {
      path: workspacesBasePath[WorkspaceList.PILOTAGE_RH],
      element: <PilotageRh.Routes />,
    },
    {
      path: '',
      element: <Global.Routes />,
    },
  ];

  return (
    <Suspense>
      <CanAccess fallback={<CatchAllNavigate to="/" />}>
        <RouterRoutes>
          <Route
            element={
              <Authenticated key="authenticated-routes" fallback={<CatchAllNavigate to="/login" />}>
                <DashboardLayout>
                  <DashboardContent>
                    <Outlet />
                  </DashboardContent>
                </DashboardLayout>
              </Authenticated>
            }
          >
            {routes.map(({path, element}) => (
              <Route key={path} path={`${path}/*`} element={element} />
            ))}
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<ErrorComponent />} />
        </RouterRoutes>
      </CanAccess>
    </Suspense>
  );
};
